import React from "react";
import { Link } from "react-router-dom";
import { RotateCcw, Shield, Truck, PhoneCall } from "lucide-react";

// Global footer — shows on every public route. Modular, single component.
// Do not add anything site-specific that would conflict with the admin area.
export const Footer = () => (
  <footer
    data-testid="site-footer"
    className="mt-16 border-t border-black/10 bg-white/60 backdrop-blur-xl"
  >
    <div className="max-w-6xl mx-auto px-5 sm:px-8 py-8 sm:py-10 grid grid-cols-2 sm:grid-cols-4 gap-6 text-sm">
      <div className="col-span-2 sm:col-span-1">
        <p className="font-display text-lg text-[#0B0C10] mb-1">MastiBazaar</p>
        <p className="text-xs text-neutral-600 leading-relaxed">
          Premium D2C fashion & lifestyle — direct to your doorstep across India.
        </p>
      </div>

      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-2">
          Policies
        </p>
        <ul className="space-y-1.5">
          <li>
            <Link
              to="/return-policy"
              data-testid="footer-return-policy"
              className="inline-flex items-center gap-1.5 text-neutral-700 hover:text-[#0B0C10]"
            >
              <RotateCcw size={12} strokeWidth={1.8} />
              Return Policy
            </Link>
          </li>
          <li>
            <Link
              to="/privacy-policy"
              data-testid="footer-privacy-policy"
              className="inline-flex items-center gap-1.5 text-neutral-700 hover:text-[#0B0C10]"
            >
              <Shield size={12} strokeWidth={1.8} />
              Privacy Policy
            </Link>
          </li>
        </ul>
      </div>

      <div>
        <p className="text-[10px] uppercase tracking-[0.2em] text-neutral-500 mb-2">
          Shopping
        </p>
        <ul className="space-y-1.5 text-neutral-700">
          <li className="inline-flex items-center gap-1.5">
            <Truck size={12} strokeWidth={1.8} />
            Free shipping across India
          </li>
          <li className="inline-flex items-center gap-1.5">
            <PhoneCall size={12} strokeWidth={1.8} />
            Cash on Delivery available
          </li>
        </ul>
      </div>

      <div className="col-span-2 sm:col-span-1 text-neutral-600 text-xs leading-relaxed">
        © {new Date().getFullYear()} MastiBazaar. All rights reserved.
      </div>
    </div>
  </footer>
);
